import { ITextFieldProps, TextField } from "@fluentui/react/lib/TextField";
import React, { InputHTMLAttributes, RefAttributes } from "react";
import { IIconProps, IRenderFunction } from "@fluentui/react";
import { IconButton } from "@fluentui/react/lib/Button";

export interface ActionableTextFieldAction {
  key: string;
  label: string;
  iconProps: IIconProps;
  onClick: () => void;
}

const onRenderInputWrapper: (
  actions: ActionableTextFieldAction[]
) => IRenderFunction<InputHTMLAttributes<HTMLInputElement> & RefAttributes<HTMLInputElement>> =
  (actions) =>
  // eslint-disable-next-line react/display-name
  (props, defaultRender) => {
    const { disabled } = props || {};
    return (
      <>
        {defaultRender(props)}
        {actions.map((action) => (
          <IconButton
            aria-label={action.label}
            iconProps={action.iconProps}
            onClick={action.onClick}
            disabled={disabled}
            key={action.key}
            tabIndex={0}
          />
        ))}
      </>
    );
  };

export const ActionableTextField = ({
  actions,
  ...textFieldProps
}: Omit<ITextFieldProps, "onRenderInput"> & {
  actions: ActionableTextFieldAction[];
}) => {
  return <TextField onRenderInput={onRenderInputWrapper(actions)} {...textFieldProps} />;
};
